<script>
export default {
  props: {
    cost: Object
  },
  filters: {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
    // https://flaviocopes.com/how-to-format-number-as-currency-javascript/
    priceFormat: (value, currency) => {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency, // usd
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    floatVal: value => {
      return value.toFixed(2);
    }
  }
};
</script>
<template>
  <div class="col-md-12 cost">
    <h4 class="mb-3">Total Cost</h4>
    <h5
      class="mb-3"
    >{{cost.cost_quantity|priceFormat(cost.cost_currency)}} (hours: {{cost.cost_hours}})</h5>
  </div>
</template>